import { Slot } from "expo-router"
import config from "@/config"
import OAuthProvider from "@/components/auth/OAuthProvider"
import { useStore } from "@nanostores/react"
import { $authToken } from "@/stores/auth"
import { useEffect } from "react"
import { useDeepLinkReroute } from "@/stores/branch"
import { BFLogoScreen } from "@/components/standard/screen/BFLogoScreen"

export default function OnboardingLayout() {
  const deepLinkReroute = useDeepLinkReroute()
  const authToken = useStore($authToken)

  useEffect(() => {
    if (authToken) {
      setTimeout(() => {
        deepLinkReroute()
      })
    }
  }, [authToken])

  return (
    <OAuthProvider clientId={config.GOOGLE_WEB_CLIENT_ID}>
      <BFLogoScreen>
        <Slot />
      </BFLogoScreen>
    </OAuthProvider>
  )
}
